import { LineSeparator } from '@/components/LineSeparator';
import { useEventStore } from '@/stores/useEventStore';
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { UpdateEventGeneralCover } from './UpdateEventGeneralCover';
import { UpdateEventGeneralDelete } from './UpdateEventGeneralDelete';
import { UpdateEventGeneralInformations } from './UpdateEventGeneralInformations';
export const UpdateEventGeneralIndex = () => {
  const { showEvent } = useEventStore();
  const { id } = useParams();

  useEffect(() => {
    const fetchEventData = async () => {
      await showEvent(Number(id));
    };

    fetchEventData();
  }, [id, showEvent]);

  return (
    <div className="flex flex-col gap-6">
      <UpdateEventGeneralCover />
      <LineSeparator />
      <UpdateEventGeneralInformations />
      <LineSeparator />
      <UpdateEventGeneralDelete />
    </div>
  );
};
